import React from 'react';
import { Chip } from '@mui/material';
import {
    HourglassEmpty,
    Queue,
    Sync,
    CheckCircle,
    Cancel
} from '@mui/icons-material';

// Status configuration object
const getStatusConfig = (status) => {
    const configs = {
        PENDING: {
            icon: <HourglassEmpty sx={{ fontSize: '0.75rem' }} />,
            bgcolor: '#fff3cd',
            color: '#856404',
            borderColor: '#ffeaa7'
        },
        QUEUED: {
            icon: <Queue sx={{ fontSize: '0.75rem' }} />,
            bgcolor: '#d1ecf1',
            color: '#0c5460',
            borderColor: '#bee5eb'
        },
        PROCESSED: {
            icon: <Sync sx={{ fontSize: '0.75rem' }} />,
            bgcolor: '#d4edda',
            color: '#155724',
            borderColor: '#c3e6cb'
        },
        COMPLETED: {
            icon: <CheckCircle sx={{ fontSize: '0.75rem' }} color='success'/>,
            bgcolor: '#d1e7dd',
            color: '#0ba918ff',
            borderColor: '#badbcc'
        },
        CANCELLED: {
            icon: <Cancel sx={{ fontSize: '0.75rem',color: '#721c24' }} />,
            bgcolor: '#f8d7da',
            color: '#721c24',
            borderColor: '#f5c6cb'
        }
    };

    return configs[status] || {
        icon: <HourglassEmpty sx={{ fontSize: '0.75rem' }} />,
        bgcolor: '#e2e3e5',
        color: '#383d41',
        borderColor: '#d6d8db'
    };
};

// Your chip component
const StatusChip = ({ notificationData }) => {
    const statusConfig = getStatusConfig(notificationData?.status);

    return (
        <Chip
            icon={statusConfig.icon}
            label={notificationData?.status}
            size="small"
            variant="outlined"
            sx={{
                fontSize: '0.65rem',
                height: 15,
                mr: 0.5,
                ml: 0.5,
                mb: 0.5,
                bgcolor: statusConfig.bgcolor,
                color: statusConfig.color,
                borderColor: statusConfig.borderColor,
                '& .MuiChip-icon': {
                    marginLeft: '4px',
                    marginRight: '-2px',
                    fontSize: '0.65rem'
                }
            }}
        />
    );
};

export default StatusChip;